import React from 'react'
import Icons from '@atoms/Icons/Icons'
import { IconButtonProps } from './IconButton.types'

const IconButton = ({
  className,
  onClick,
  iconName,
  height,
  width,
  color
}: IconButtonProps) => {
  return (
    <div
      className={`flex cursor-pointer items-center ${className}`}
      onClick={onClick && (() => onClick())}
    >
      <Icons iconName={iconName} height={height} width={width} color={color} />
    </div>
  )
}

export default IconButton
